import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.checkStatus()
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    this.abortController?.abort()
  }

  async checkStatus() {
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store",
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const result = await response.json()
      if (!result.processing) {
        Turbo.visit(window.location.href, { action: "replace" })
        return
      }
    } catch (error) {
      if (error.name === "AbortError") return
    }

    this.timeout = window.setTimeout(() => this.checkStatus(), this.intervalValue)
  }
}
